import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingComponent } from './loading.component';
import { SpinnerComponent } from './spinner.component';

@NgModule({
  declarations: [LoadingComponent, SpinnerComponent],
  imports: [
    CommonModule
  ],
  exports: [LoadingComponent, SpinnerComponent]
})
export class LoadingModule { }
